<template>
  <div class="spacey-20">
    <form @submit.prevent="$emit('submit')">
      <slot />
    </form>
    <ErrorAlert v-if="error" :error="error" />
    <SuccessAlert v-else-if="success" :success="success" />
  </div>
</template>

<script>
  import ErrorAlert from '@/components/common/ErrorAlert';
  import SuccessAlert from '@/components/common/SuccessAlert';

  export default {
    name: 'Form',
    components: { SuccessAlert, ErrorAlert },
    props: {
      error: {
        type: [Boolean, String],
        default: null,
      },
      success: {
        type: [Boolean, String],
        default: null,
      },
      errorText: String,
      successText: String,
    },
  };
</script>
